(function () {
  'use strict';

  /* @ngdoc object
   * @name crewSetReport
   * @description
   *
   */
  angular
    .module('crewSetReport', [
      'ui.router'
    ]);
}());
